export class ProfileModel {
    keyword = '';
    role_id = 0;
    clinic_id = 0;
    clinic;
    login_type;
    role;
    email_notification;
}
